<template>
  <div>
<!--    <div class="blue-button" @click="resetAddressLocation">Reset</div>-->
    <div class="vx-row" v-if="shape">
      <div class="map-top-option vx-col w-1/3" @click="rollback"><i class="fas fa-undo-alt"></i> Undo</div>
      <div class="map-top-option vx-col w-1/3 text-center" @click="refresh_color"><i class="fas fa-palette"></i> Change Color</div>
      <div class="map-top-option vx-col w-1/3 text-right" @click="refresh"><i class="fas fa-eraser"></i> Reset</div>
    </div>
    <div class="vx-col w-full" id="map-container" style="height: 675px;">
      <transition name="slide-fade">
        <div  v-if="controlToggle" class="p-4 controls-wrapper flex flex-col items-stretch">
          <div class="w-full flex-grow-0 mt-2">
            <div class="zone-section-heading">Name</div>
            <input class="zone-input " type="text"  v-model="name" v-validate="'required'" name="Name" />
          </div>
          <div class="w-full flex-grow-0 mt-2">
            <div class="zone-section-heading">Estimate Time</div>
            <input class="zone-input" type="text"  v-model="estimatedTime" v-validate="'required'" name="Estimated Time" />
          </div>
          <div class="w-full flex-grow-0 mt-2">
            <div class="zone-section-heading">Delivery Fee</div>
            <input class="zone-input" type="text" v-model="price" v-validate="'required'" name="Price" />
          </div>
          <div class="w-full flex-grow-0 mt-2">
            <div class="zone-section-heading">Min Order Amount</div>
            <input class="zone-input" type="text" v-model="minPrice" v-validate="'required'" name="Min Price" />
          </div>
           <div class="w-full flex-grow-0 mt-2 zone-wrapper" v-if="shape.zones">
            <div class="zone-section-heading">Zones</div>
            <span v-for="(zone, index) in shape.zones" :key="index">{{zone.district ? zone.district : zone.city}}{{ index !== shape.zones.length -1 ? ',' : '' }} </span>
          </div>
          <div class="save-wrapper flex-1">
            <h5 v-if="!confirmDataBool" class="text-center zone-save cursor-pointer" @click="confirmData"><i class="fas fa-check"></i> Confirm</h5>
            <h5 v-else class="text-center zone-save cursor-pointer" @click="() => {
              if (selectedBoundary) {
                this.editNewData()
              } else {
                this.saveNewData()
              }
            }"><i class="fas fa-save"></i> Save</h5>
            <h5 v-if="selectedBoundary" class="text-center zone-save cursor-pointer" @click="deleteBoundary"><i class="fas fa-trash"></i> Delete</h5>
          </div>
          <h3 class="zone-cancel cursor-pointer" @click="refresh"><i class="fas fa-ban"></i> Cancel</h3>
        </div>
      </transition>
      <transition name="slide-fade">
        <div  v-if="errorToggle" class="p-4 error-wrapper flex flex-col items-stretch">
          <div class="w-full flex-grow-0 mt-2">
           <span class="text-danger text-sm"
                 v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
          <div class="w-full flex-grow-0 mt-2">

            <span class="text-danger text-sm"
                  v-show="errors.has('Estimated Time')">{{ errors.first('Estimated Time') }}</span>
          </div>
          <div class="w-full flex-grow-0 mt-2">
            <span class="text-danger text-sm"
                  v-show="errors.has('Price')">{{ errors.first('Price') }}</span>
          </div>
          <div class="save-wrapper flex-1">
            <h5 class="text-center zone-save cursor-pointer" @click="errorToggle = false"><i class="fas fa-ban"></i> Dismiss</h5>
          </div>
        </div>
      </transition>
      <div ref="result"></div>
      <div ref="result2"></div>
      <google-map id="map"
                  v-if="defaultMapOptions.center.lat"
                  @click="generateNewZone"
                  ref="Map" class="h-full" :options="defaultMapOptions" :center.sync="defaultMapOptions.center">
        <google-map-marker
          :position.sync="location"
          :show.sync="showInfo"
          :icon="{url: require('@/assets/images/logo/pin.png'), scaledSize: {width: 64, height: 64}}"
        />
        <google-map-infowindow
          :show.sync="showInfo"
          :position.sync="location"
          :options="{
            pixelOffset: {
              width: 0,
              height: -75
            }
          }"
          @info-window-clicked="infoClicked"
        >
          <div v-html="defaultMapOptions.description"></div>
        </google-map-infowindow>

        <google-map-polygon
          v-if="shape"
          :key="'polygon'"
          :draggable="shape.draggable"
          :clickable="shape.clickable"
          :fill-color="shape.fillColor"
          :stroke-color="shape.strokeColor"
          :paths="polygon_paths"
          @click="generateNewZone"
        ></google-map-polygon>

        <google-map-polygon
          v-if="!shape && polyZones.length > 0"
          v-for="(polygon, index) in polyzones_reversed"
          :key="`polygon${index}`"
          :ref="`polygon${index}`"
          class="cursor-default"
          :draggable="polygon.draggable"
          :clickable="polygon.clickable"
          :fill-color="polygon.fillColor"
          :stroke-color="polygon.strokeColor"
          :paths="polygon.paths"
          @click="edit(polyboundary_reversed[index])"
        ></google-map-polygon>

        <google-map-circle
          :center="location"
          @click="mark"
          ref="circle"
          :radius="radius"
          :visible="false"
          :fillColor="'red'"
          :fillOpacity="0.1"
        />

      </google-map>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    restaurant: {
      type: Object
    },
    saved: {
      type: Function
    },
    edit: {
      type: Function
    },
    boundaries: {
      type: Array
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.api.currentUser
    },
    polyzones_reversed () {
      return JSON.parse(JSON.stringify(this.polyZones)).reverse()
    },
    polyboundary_reversed () {
      return JSON.parse(JSON.stringify(this.polyBoundaries)).reverse()
    },
    polygon_paths () {
      const result_arr = JSON.parse(JSON.stringify(this.shape.paths))
      const first_index = 0
      result_arr.push(result_arr[first_index])
      return result_arr
    },
    restaurant_list () {
      return this.$store.state.api.restaurantlist
    }
  },
  name: 'DefineBoundary',
  data () {
    return {
      shape: null,
      polyZones: [],
      polyBoundaries: [],
      showMap: false,
      isAdd: false,
      isEdit: false,
      controlToggle: false,
      confirmDataBool: false,
      errorToggle: false,
      radius: 0,
      defaultMapOptions: {
        center: {
          lat: 0,
          lng: 0
        },
        draggableCursor: 'url(http://s3.amazonaws.com/besport.com_images/status-pin.png), auto',
        title: 'Delivery Location',
        description: '',
        gestureHandling: 'greedy',
        mapTypeControl: false,
        draggable:true,
        zoomControl: true,
        styles: [
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'administrative.province',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ff0000'
              }
            ]
          },
          {
            featureType: 'administrative.province',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#ff0000'
              }
            ]
          }
        ]
      },
      mapHeight: 0,
      color: null,
      showInfo: false,
      location:null,
      geocoder: null,
      placeService: null,
      infoloc: {
        lat: 0,
        lng: 0
      },
      name: '',
      estimatedTime: '',
      price: '',
      minPrice: 0,
      is_drawing: false,
      id: null,
      selectedBoundary: null
    }
  },
  mounted () {
    this.geocoder = new window.google.maps.Geocoder(this.$refs.result)
    this.placeService = new window.google.maps.places.PlacesService(this.$refs.result2)
    this.getRestaurantLocation()
    setTimeout(() => {
      this.setBoundaryData()
    }, 500)

  },
  watch: {
    radius () {
      //this.$refs.Map.fitBounds(this.$refs.circle.getBounds())
    },
    selectedBoundary () {
    },
    shape () {
      this.showInfo = this.shape
    }
  },
  methods: {
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        clickNotClose: true,
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    deleteBoundary () {
      this.openConfirm(() => {
        this.$vs.loading()
        const obj = {
          boundaryId: this.selectedBoundary.id,
          restaurantId: this.selectedBoundary.restaurant_id
        }
        this.$store.dispatch('api/removeBoundary', obj)
          .then(() => {
            this.$vs.loading.close()
            this.saved()
          })
          .catch(err => {
            console.error(err)
            this.$vs.loading.close()
          })
      }, () => {})
    },
    calculatePolygonArea (polygon) {
      return window.google.maps.geometry.spherical.computeArea(polygon.paths)
    },
    getPolygonDistricts (polygon) {
      polygon.paths.map(path => {
        this.getPlaceDetails(path, () => {
        })
      })
    },
    getPlaceDetails (location, callback) {
      this.geocoder.geocode({location}, (response, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          callback(response)
        }
      })
    },
    generateRandomColor () {
      const maxVal = 0xFFFFFF // 16777215
      let randomNumber = Math.random() * maxVal
      randomNumber = Math.floor(randomNumber)
      randomNumber = randomNumber.toString(16)
      const randColor = randomNumber.padStart(6, 0)
      return `#${randColor.toUpperCase()}`
    },
    shadeColor (color, percent) {

      let R = parseInt(color.substring(1, 3), 16)
      let G = parseInt(color.substring(3, 5), 16)
      let B = parseInt(color.substring(5, 7), 16)

      R = parseInt(R * (100 + percent) / 100)
      G = parseInt(G * (100 + percent) / 100)
      B = parseInt(B * (100 + percent) / 100)

      R = (R < 255) ? R : 255
      G = (G < 255) ? G : 255
      B = (B < 255) ? B : 255

      const RR = ((R.toString(16).length === 1) ? `0${R.toString(16)}` : R.toString(16))
      const GG = ((G.toString(16).length === 1) ? `0${G.toString(16)}` : G.toString(16))
      const BB = ((B.toString(16).length === 1) ? `0${B.toString(16)}` : B.toString(16))

      return `#${RR}${GG}${BB}`
    },
    confirmData () {
      this.shape.paths.splice(this.shape.paths[this.shape.paths.length - 1], 1)
      this.shape.paths.push(this.shape.paths[0])
      this.confirmDataBool = true
      this.fitZoneBounds(this.shape)
    },
    generateNewZone ($event) {
      if (!this.is_drawing) {
        this.color = this.generateRandomColor()
        this.shape = {
          fillColor: this.color,
          strokeColor: this.shadeColor(this.color, 20),
          draggable: false,
          clickable: true,
          paths: [this.location],
          zones: []
        }
        this.is_drawing = true
      }
      this.mark($event)
    },
    getShapeFromBoundary (boundary) {
      const { geometry, zones, color } = boundary
      this.areas = geometry.coordinates[0][0]

      const paths = []
      this.areas.map(area => {
        const lat = parseFloat(area[1])
        const lng = parseFloat(area[0])

        const path = {
          lat,
          lng
        }
        paths.push(path)
      })


      const boundary_shape = {
        fillColor: color,
        strokeColor: this.shadeColor(color, 20),
        draggable: false,
        clickable: true,
        paths,
        zones
      }

      return boundary_shape
    },
    setBoundaryData () {
      this.boundaries.map(boundary => {
        const boundary_shape = this.getShapeFromBoundary(boundary)
        this.polyZones.push(boundary_shape)
        this.polyBoundaries.push(boundary)
      })

      this.fitBounds(null, false)
    },
    getMaxZone () {
      if (this.polyZones.length > 1) {
        const zone = this.polyZones.reduce((prev, curr) => {
          if (this.calculatePolygonArea(prev) < this.calculatePolygonArea(curr)) {
            return curr
          } else {
            return prev
          }
        })
        return zone
      } else if (this.polyZones.length > 0) {
        return this.polyZones[0]
      }
    },
    setEdit (boundary) {
      this.selectedBoundary = boundary

      const { id, name, price, minPrice, estimatedTime } = boundary
      this.id = id
      this.name = name
      this.price = price
      this.minPrice = minPrice
      this.estimatedTime = estimatedTime

      this.controlToggle = true
    },
    fitBounds (boundary, isFocus) {
      const zone = boundary ? this.getShapeFromBoundary(boundary) : this.getMaxZone()
      this.fitZoneBounds(zone)
      if (boundary) {
        this.setEdit(boundary)
      }

      if (isFocus) {
        this.shape = zone
      } else {
        this.shape = null
      }
    },
    fitZoneBounds (zone) {
      const bounds = new window.google.maps.LatLngBounds()
      if (zone) {
        if (zone.paths) {
          zone.paths.map(path => {
            bounds.extend(path)
          })
        }
      } else {
        bounds.extend(this.defaultMapOptions.center)
      }

      this.$refs.Map.fitBounds(bounds)
      //this.getPolygonDistricts(zone)
    },
    saveNewData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.polyZones.push(this.shape)
          const areas = []
          this.shape.paths.map(point => {
            areas.push(`${point.lat} ${point.lng}`)
          })


          const obj = {
            boundaryId: null,
            restaurantId: this.restaurant.id,
            boundaryName: this.name,
            price: this.price,
            minPrice: this.minPrice,
            estimatedTime: this.estimatedTime,
            color: this.color,
            areas,
            zones: this.shape.zones
          }

          this.$store.dispatch('api/setBoundary', obj)
            .then(() => {
              this.$emit('closeSidebar')
              this.saved()
              this.refresh()
            })
            .catch(err => {
              console.error(err)
            })

        }
      })
    },
    editNewData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            boundaryId: this.selectedBoundary.id,
            restaurantId: this.restaurant.id,
            boundaryName: this.name,
            price: this.price,
            minPrice: this.minPrice,
            estimatedTime: this.estimatedTime,
            color: this.selectedBoundary.color
          }

          this.$store.dispatch('api/setBoundary', obj)
            .then(() => {
              this.$vs.loading.close()
              this.$emit('closeSidebar')
              this.saved()
              this.refresh()
            })
            .catch(err => {
              console.error(err)
              this.$vs.loading.close()
            })
        }
      })
    },
    mark (event) {
      if (this.confirmDataBool) {
        return false
      }

      if (!this.controlToggle) {
        this.controlToggle = true
      }

      const clicked_pos = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      }
      const distance = window.google.maps.geometry.spherical.computeDistanceBetween(this.location, clicked_pos)
      this.radius = distance
      this.shape.paths.push(clicked_pos)

      //this.fitZoneBounds(this.shape)
      this.getPlaceDetails(clicked_pos, (response) => {
        let locality = null, sublocality = null

        const result = response.filter(item => item.address_components.filter(comp => comp.types.includes('administrative_area_level_1')).length > 0)
        const result1 = response.filter(item => item.address_components.filter(comp => comp.types.includes('locality')).length > 0)
        const result2 = response.filter(item => item.address_components.filter(comp => comp.types.includes('sublocality')).length > 0)
        const result3 = response.filter(item => item.address_components.filter(comp => comp.types.includes('administrative_area_level_2')).length > 0)

        result.filter(item => {
          item.address_components.filter(comp => {
            if (comp.types.includes('administrative_area_level_1')) {
              if (!locality) {
                locality = comp.long_name
              }
            }
          })
        })

        if (result1.length > 0) {
          result1.filter(item => {
            item.address_components.filter(comp => {
              if (comp.types.includes('locality')) {
                if (locality !== comp.long_name && !sublocality) {
                  sublocality = comp.long_name
                }
              }
            })
          })
          //sublocality = result1[0].address_components.filter(comp => comp.types.includes('locality'))[0].long_name
        }
        if (!sublocality && result2.length > 0) {
          result2.filter(item => {
            item.address_components.filter(comp => {
              if (comp.types.includes('sublocality')) {
                if (locality !== comp.long_name && !sublocality) {
                  sublocality = comp.long_name
                }
              }
            })
          })
          //sublocality = result2[0].address_components.filter(comp => comp.types.includes('sublocality'))[0].long_name
        }
        if (!sublocality && result3.length > 0) {
          result3.filter(item => {
            item.address_components.filter(comp => {
              if (comp.types.includes('administrative_area_level_2')) {
                if (locality !== comp.long_name && !sublocality) {
                  sublocality = comp.long_name
                }
              }
            })
          })

          //sublocality = result3[0].address_components.filter(comp => comp.types.includes('administrative_area_level_2'))[0].long_name
        }
        if (locality && sublocality) {
          const item = {
            city: locality,
            district: sublocality
          }
          if (this.shape.zones.filter(zone => zone.city === item.city && zone.district === item.district).length === 0) {
            this.shape.zones.push(item)
          }
        }
      })
    },
    centerMark () {
      if (!this.is_drawing) {
        this.color = this.generateRandomColor()
        this.shape = {
          fillColor: this.color,
          strokeColor: this.shadeColor(this.color, 20),
          draggable: false,
          clickable: true,
          paths: [this.location],
          zones: []
        }
        this.is_drawing = true
      }
      if (this.confirmDataBool) {
        return false
      }

      if (!this.controlToggle) {
        this.controlToggle = true
      }

      const clicked_pos = JSON.parse(this.restaurant.user_property['Location'])
      this.radius = window.google.maps.geometry.spherical.computeDistanceBetween(this.location, clicked_pos)
      this.shape.paths.push(clicked_pos)

      //this.fitZoneBounds(this.shape)
      this.getPlaceDetails(clicked_pos, (response) => {
        let locality = null, sublocality = null

        const result = response.filter(item => item.address_components.filter(comp => comp.types.includes('administrative_area_level_1')).length > 0)
        const result1 = response.filter(item => item.address_components.filter(comp => comp.types.includes('locality')).length > 0)
        const result2 = response.filter(item => item.address_components.filter(comp => comp.types.includes('sublocality')).length > 0)
        const result3 = response.filter(item => item.address_components.filter(comp => comp.types.includes('administrative_area_level_2')).length > 0)

        result.filter(item => {
          item.address_components.filter(comp => {
            if (comp.types.includes('administrative_area_level_1')) {
              if (!locality) {
                locality = comp.long_name
              }
            }
          })
        })

        if (result1.length > 0) {
          result1.filter(item => {
            item.address_components.filter(comp => {
              if (comp.types.includes('locality')) {
                if (locality !== comp.long_name && !sublocality) {
                  sublocality = comp.long_name
                }
              }
            })
          })
          //sublocality = result1[0].address_components.filter(comp => comp.types.includes('locality'))[0].long_name
        }
        if (!sublocality && result2.length > 0) {
          result2.filter(item => {
            item.address_components.filter(comp => {
              if (comp.types.includes('sublocality')) {
                if (locality !== comp.long_name && !sublocality) {
                  sublocality = comp.long_name
                }
              }
            })
          })
          //sublocality = result2[0].address_components.filter(comp => comp.types.includes('sublocality'))[0].long_name
        }
        if (!sublocality && result3.length > 0) {
          result3.filter(item => {
            item.address_components.filter(comp => {
              if (comp.types.includes('administrative_area_level_2')) {
                if (locality !== comp.long_name && !sublocality) {
                  sublocality = comp.long_name
                }
              }
            })
          })

          //sublocality = result3[0].address_components.filter(comp => comp.types.includes('administrative_area_level_2'))[0].long_name
        }
        if (locality && sublocality) {
          const item = {
            city: locality,
            district: sublocality
          }
          if (this.shape.zones.filter(zone => zone.city === item.city && zone.district === item.district).length === 0) {
            this.shape.zones.push(item)
          }
        }
      })
    },
    openMap () {

      const urlSuffix = this.restaurant.user_property.Address
      window.open(
        'https://www.google.com/maps/search/?api=1&query='.concat(urlSuffix),
        '_blank'
      )
    },
    async getRestaurantLocation () {

      if (this.restaurant.user_property['Location']) {
        const location = JSON.parse(this.restaurant.user_property['Location'])
        if (location) {
          this.defaultMapOptions.center = location
          this.location = location
          this.infoloc = location

          this.defaultMapOptions.description = `<h5>Start Drawing a Zone by Pinning on Map</h5><p>${this.restaurant.user_property['Address']}</p>`


          this.defaultMapOptions.title = 'Delivery Location'
          this.showInfo = true
        }

      } else {
        const addressObj = {
          address: this.restaurant.user_property['Address'],
          country: 'United States'
        }

        //todo replace geocoder with vue meta geocode lib
        this.geocoder.geocode(addressObj, (response, status) => {
          if (status === window.google.maps.GeocoderStatus.OK) {

            this.defaultMapOptions.center = {
              lat: response[0].geometry.location.lat(),
              lng: response[0].geometry.location.lng()
            }
            this.location = {
              lat: response[0].geometry.location.lat(),
              lng: response[0].geometry.location.lng()
            }
            this.infoloc = {
              lat: response[0].geometry.location.lat(),
              lng: response[0].geometry.location.lng()
            }


            this.defaultMapOptions.description = `<h5>Start Drawing a Zone by Pinning on Map</h5><p>${addressObj.address}</p>`


            this.defaultMapOptions.title = 'Delivery Location'
            this.showInfo = true
          }
        })
      }
    },
    rollback () {
      this.shape.paths.splice(this.shape.paths.length - 1, 1)
    },
    refresh () {
      this.shape = null
      this.confirmDataBool = false
      this.is_drawing = false
      this.name = ''
      this.price = ''
      this.minPrice = 0
      this.estimatedTime = ''
      this.selectedBoundary = null
      this.controlToggle = false

      this.fitBounds(null, false)

    },
    refresh_color () {

      const color = this.generateRandomColor()
      this.shape.fillColor = color
      this.shape.strokeColor = this.shadeColor(color, 20)
      this.color = color
    },
    toggleInfoWindow () {
      this.showInfo = true
    },
    infoClicked () {
    },

    async getRestaurantLoc (restaurant) {

      const addressObj = {
        address: restaurant.user_property['Address'],
        country: 'United States'
      }

      //todo replace geocoder with vue meta geocode lib
      this.geocoder.geocode(addressObj, (response, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {

          const loccy = {
            lat: response[0].geometry.location.lat(),
            lng: response[0].geometry.location.lng()
          }
          this.saveLocationRestaurant(restaurant, loccy)
        }
      })
    },
    resetAddressLocation () {
      const self = this
      let index = 0
      const intervy = setInterval(() => {
        if (index < self.restaurant_list.length) {
          const restaurant = self.restaurant_list[index]
          self.getRestaurantLoc(restaurant)
          index++
        } else {
          clearInterval(intervy)
        }
      }, 4000)
    },

    saveLocationRestaurant (restaurant, location) {
      const payload = {
        user_id: restaurant.id,
        email: restaurant.email,
        name: restaurant.name,
        phone: restaurant.phone,
        last_name: restaurant.last_name,
        user_group: 2,
        property: {
          'Location': JSON.stringify(location)
        }
      }

      this.$store.dispatch('api/updateUserLocation', payload).then(() => {
      }).catch(err => {
        console.error(err.message)
      })

    }
  }
}
</script>

<style lang="scss">
.zone-wrapper {
  max-height: 100px;
  overflow-y: auto;
}
.controls-wrapper {
  input{
    border:1px solid #ccc;
  }
  .zone-cancel{
    background:whitesmoke;
    padding:5px 10px 5px 10px;
    right:-2px;
    top:-53px;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-left:2px solid #ccc;
    border-top:2px solid #ccc;
    border-right:2px solid #ccc;
  }
  width: 200px;
  height: 400px;
  position: absolute;
  background: whitesmoke;
  bottom:20px;
  z-index: 1;
  border-top:2px solid #ccc;
  border-right:2px solid #ccc;
  border-bottom:2px solid #ccc;
  border-bottom-right-radius: 7px;
}
.error-wrapper {
  width: 200px;
  height: auto;
  position: absolute;
  background: whitesmoke;
  top: 13%;
  z-index: 1;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .11), 0 5px 15px 0 rgba(0, 0, 0, .08) !important;
}
#map-container {
  position: relative;
  overflow: hidden;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.save-wrapper {
  position: relative;
  h3 {
    margin-top: auto;
    position: absolute;
    bottom:0;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
#map-container {
  margin:20px 0;
}
.map-top-option{
  cursor:pointer;
  max-width:max-content;
  &:hover{
    text-decoration: underline;
  }
}
</style>
